import { useEffect, useRef } from 'react';

const ZoomAlert = () => {
    const lastZoomLevel = useRef<number | null>(null);
    const alertActive = useRef(false);
    const resizeTimeout = useRef<NodeJS.Timeout | null>(null);
    const isResizing = useRef(false);

    const isIOS = () => {
        const userAgent = navigator.userAgent.toLowerCase();
        return /iphone|ipad|ipod|macintosh/i.test(userAgent);
    };

    useEffect(() => {
        const ua = navigator.userAgent.toLowerCase();
        const isFirefox = ua.includes('firefox');
        const isSafari = ua.includes('safari') && !ua.includes('chrome');
        const isEdge = ua.includes('edg');
        const isChrome = ua.includes('chrome') && !isEdge;

        const getZoomLevel = () => {
            if (isChrome || isEdge) {
                return Math.round((window.outerWidth / window.innerWidth) * 100);
            }

            if (isFirefox) {
                const width = window.innerWidth;
                const dpr = Math.round(window.devicePixelRatio * 100);

                if (isIOS() && dpr > 200) return dpr;
                if (!isIOS() && width < 430 && dpr > 300) return dpr;
                if (!isIOS() && (width > 430 && width < 1536) && dpr > 125) return dpr;
                if (!isIOS() && (width > 1536 && width < 1920) && dpr > 100) return dpr;
            }

            if (isSafari) {
                return 100;
            }

            return 100;
        };

        const showAlert = () => {
            if (alertActive.current) return;
            alertActive.current = true;

            alert(`⚠️ Your browser zoom is detected to be above 100%. Please reset it to 100% for the best experience.`);

            setTimeout(() => {
                alertActive.current = false;
            }, 500);
        };

        const checkZoom = () => {
            if (isResizing.current) return;

            const currentZoom = getZoomLevel();

            if (currentZoom <= 105) {
                lastZoomLevel.current = null;
                return;
            }

            if (currentZoom === lastZoomLevel.current) return;

            lastZoomLevel.current = currentZoom;
            showAlert();
        };

        const onResize = () => {
            isResizing.current = true;
            if (resizeTimeout.current) clearTimeout(resizeTimeout.current);

            resizeTimeout.current = setTimeout(() => {
                isResizing.current = false;
                checkZoom();
            }, 400);
        };

        checkZoom();

        window.addEventListener('resize', onResize);
        const interval = setInterval(checkZoom, 2000);

        return () => {
            window.removeEventListener('resize', onResize);
            if (resizeTimeout.current) clearTimeout(resizeTimeout.current);
            clearInterval(interval);
        };
    }, []);

    return null;
};

export default ZoomAlert;